import { useEffect } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import ReactGA from "react-ga4";
import { getInvoiceFeature } from "../../core/service/api_invoice";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ComponentInvoiceMobile from "./ComponentInvoiceMobile";
import ComponentInvoiceWeb from "./ComponentInvoiceWeb";
const ComponentInvoice = () => {
  const gaEventTracker = useAnalyticsEventTracker("Invoice");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Invoice",
    });
    getFeature();
  }, []);
  const getFeature = async () => {
    const res = await getInvoiceFeature();
    console.log("res", res);
    localStorage.setItem("invoice-feature", JSON.stringify(res.data));
  };
  return (
    <>
      <BrowserView>
        <ComponentInvoiceWeb></ComponentInvoiceWeb>
      </BrowserView>
      <MobileView>
        <ComponentInvoiceMobile></ComponentInvoiceMobile>
      </MobileView>
    </>
  );
};
export default ComponentInvoice;
